.atm_e2_1wugsn5{height:auto;}
.atm_l8_9o6drx{padding:8px 16px;}
.atm_vy_1osqo2v{width:100%;}
.atm_9s_11p5wf0{display:grid;}
.atm_cx_ftgil2{gap:8px;}
.atm_dz_1ghlemp.atm_dz_1ghlemp{grid-template-columns:1fr auto;}
.atm_e2_1osqo2v{height:100%;}
.atm_9s_1txwivl{display:flex;}
.atm_be_1g80g66.atm_be_1g80g66{flex-wrap:wrap;}
.atm_ax_kb7nvz.atm_ax_kb7nvz{flex-grow:1;}
.atm_ap_184xf1m.atm_ap_184xf1m{flex-basis:min-content;}
.atm_mk_stnw88{position:absolute;}
.atm_fq_exct8b{left:16px;}
.atm_tk_1ssbidh{top:50%;}
.atm_tr_1i34xl8{transform:translateY(-50%);}
.atm_7l_17ntfr6{color:gray;}
.atm_mj_glywfm{pointer-events:none;}
